<mat-dialog-content class="mat-typography">
  <!-- Loading overlay -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <div class="spinner"></div>
      <p>Loading expense form...</p>
    </div>
  </div>
  
  <section class="add-expense-dialog-wrapper" [class.loading]="loading">
    <h2 class="cmn-popup-title">{{expenseData?.id ? 'Edit' : 'Add'}} Expense</h2>
    <button class="cmn-close" mat-dialog-close></button>
    <form [formGroup]="expenseForm" (ngSubmit)="onAddExpense('Pending')">
      <div class="expense-form-wrapper">
        <!-- Column 1 -->
        <div class="form-column">
          <div class="form-wrapper">
            <label for="">Expense Date <span class="red">*</span></label>
            <mat-form-field>
              <input 
                matInput 
                [matDatepicker]="picker" 
                placeholder="dd/mm/yyyy" 
                formControlName="expenseDate"
                [matDatepickerFilter]="dateFilter"
              />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="expenseForm.get('expenseDate')!.touched && expenseForm.get('expenseDate')!.hasError('required')">Expense date is required.</mat-error>
              </span>
            </div>
          </div>

          <div class="form-wrapper">
            <label for="">Expense Type <span class="red">*</span></label>
            <mat-form-field>
              <input 
                type="text"
                placeholder="Search expense type..." 
                matInput
                [formControl]="expenseTypeFilterCtrl"
                [matAutocomplete]="auto"
                (input)="onExpenseTypeInput()"
              />
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onExpenseTypeSelected($event)">
                <mat-option *ngFor="let expenseType of filteredExpenseTypes | async" [value]="expenseType">
                  {{ expenseType }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="expenseForm.get('expenseType')!.touched && expenseForm.get('expenseType')!.hasError('required')">Expense type is required.</mat-error>
              </span>
            </div>
          </div>

          <div class="form-wrapper">
            <label for="">Account <span class="red">*</span></label>
            <mat-form-field>
              <input 
                type="text"
                placeholder="Search account..." 
                matInput
                [formControl]="accountFilterCtrl"
                [matAutocomplete]="accountAuto"
                (input)="onAccountInput()"
              />
              <mat-autocomplete #accountAuto="matAutocomplete" (optionSelected)="onAccountSelected($event)">
                <mat-option *ngFor="let account of filteredAccounts | async" [value]="account">
                  {{ account.accountName }} ({{ account.accountCode }})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="expenseForm.get('accountId')!.touched && expenseForm.get('accountId')!.hasError('required')">Account is required.</mat-error>
              </span>
            </div>
          </div>
        </div>

        <!-- Column 2 -->
        <div class="form-column">
          <div class="form-wrapper">
            <label for="">Amount <span class="red">*</span></label>
            <mat-form-field>
              <input matInput type="number" placeholder="Enter amount" formControlName="amount" min="0.01" step="0.01" />
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="expenseForm.get('amount')!.touched && expenseForm.get('amount')!.hasError('required')">Amount is required.</mat-error>
              </span>
              <span>
                <mat-error
                  *ngIf="expenseForm.get('amount')!.touched && expenseForm.get('amount')!.hasError('min')">Amount must be greater than 0.</mat-error>
              </span>
            </div>
          </div>

          <div class="form-wrapper">
            <label for="">Tax</label>
            <mat-form-field>
              <input matInput type="number" placeholder="Enter tax amount" formControlName="tax" min="0" step="0.01" />
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="expenseForm.get('tax')!.touched && expenseForm.get('tax')!.hasError('min')">Tax must be 0 or greater.</mat-error>
              </span>
            </div>
          </div>

          <div class="form-wrapper">
            <label for="">Paid By <span class="red">*</span></label>
            <mat-form-field>
              <input 
                type="text"
                placeholder="Search employee..." 
                matInput
                [formControl]="paidByFilterCtrl"
                [matAutocomplete]="paidByAuto"
                (input)="onPaidByInput()"
              />
              <mat-autocomplete #paidByAuto="matAutocomplete" (optionSelected)="onPaidBySelected($event)">
                <mat-option *ngFor="let employee of filteredPaidByEmployees | async" [value]="employee">
                  {{ employee.firstName }} {{ employee.lastName }} ({{ employee.employeeCode }})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="expenseForm.get('paidBy')!.touched && expenseForm.get('paidBy')!.hasError('required')">Paid by is required.</mat-error>
              </span>
            </div>
          </div>
        </div>

        <!-- Column 3 -->
        <div class="form-column">
          <div class="form-wrapper">
            <label for="">Payment Method <span class="red">*</span></label>
            <mat-form-field>
                              <mat-select placeholder="Select payment method" formControlName="paymentMethod" (selectionChange)="onPaymentMethodChange($event.value)">
                  <mat-option value="CASH">Cash</mat-option>
                  <mat-option value="BANK">Bank</mat-option>
                  <mat-option value="CARD">Credit Card</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="expenseForm.get('paymentMethod')!.touched && expenseForm.get('paymentMethod')!.hasError('required')">Payment method is required.</mat-error>
              </span>
            </div>
          </div>

          <!-- Is Cheque Checkbox (only show when BANK is selected) -->
          <div class="form-wrapper" *ngIf="expenseForm.get('paymentMethod')?.value === 'BANK'">
            <div class="cheque-checkbox-container">
              <mat-checkbox formControlName="isCheque" class="cheque-checkbox">
                Is Cheque
              </mat-checkbox>
            </div>
          </div>

          <div class="form-wrapper" *ngIf="expenseForm.get('paymentMethod')?.value === 'BANK'">
            <label for="">Bank Account</label>
            <mat-form-field>
              <input 
                type="text"
                placeholder="Search bank account..." 
                matInput
                [formControl]="bankAccountFilterCtrl"
                [matAutocomplete]="bankAccountAuto"
                (input)="onBankAccountInput()"
              />
              <mat-autocomplete #bankAccountAuto="matAutocomplete" (optionSelected)="onBankAccountSelected($event)">
                <mat-option *ngFor="let account of filteredBankAccounts | async" [value]="account">
                  {{ account.bankName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="form-wrapper" *ngIf="expenseForm.get('paymentMethod')?.value === 'CARD'">
            <label for="">Credit Card</label>
            <mat-form-field>
              <input 
                type="text"
                placeholder="Search credit card..." 
                matInput
                [formControl]="creditCardFilterCtrl"
                [matAutocomplete]="creditCardAuto"
                (input)="onCreditCardInput()"
              />
              <mat-autocomplete #creditCardAuto="matAutocomplete" (optionSelected)="onCreditCardSelected($event)">
                <mat-option *ngFor="let card of filteredCreditCards | async" [value]="card">
                  {{ card.cardName }} ({{ card.cardNumberMasked }})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Cheque fields (only show when BANK is selected AND isCheque is true) -->
          <div class="form-wrapper" *ngIf="expenseForm.get('paymentMethod')?.value === 'BANK' && expenseForm.get('isCheque')?.value">
            <label for="">Cheque Number</label>
            <mat-form-field>
              <input matInput placeholder="Enter cheque number" formControlName="chequeNo" />
            </mat-form-field>
          </div>

          <div class="form-wrapper" *ngIf="expenseForm.get('paymentMethod')?.value === 'BANK' && expenseForm.get('isCheque')?.value">
            <label for="">Cheque Date</label>
            <mat-form-field>
              <input 
                matInput 
                [matDatepicker]="chequeDatePicker" 
                placeholder="dd/mm/yyyy" 
                formControlName="chequeDate"
                (dateChange)="onChequeDateChange($event)"
              />
              <mat-datepicker-toggle matIconSuffix [for]="chequeDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #chequeDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <!-- Full Width Fields -->
        <div class="form-wrapper full-width">
          <label for="">Reference Number</label>
          <mat-form-field>
            <input matInput placeholder="Enter reference number" formControlName="referenceNo" />
          </mat-form-field>
        </div>

        <div class="form-wrapper full-width">
          <label for="">Description</label>
          <mat-form-field>
            <textarea matInput placeholder="Enter description" formControlName="description" rows="3"></textarea>
          </mat-form-field>
        </div>

        <!-- Upload Section -->
        <div class="upload-section full-width">
          <div class="upload-wrapper">
            <div class="cmn-upload-box">
              <h4>Upload Documents (optional)</h4>
              <div class="upload-content">
                <input
                  #fileInput
                  type="file"
                  (change)="onFileSelected($event)"
                  formControlName="file"
                  style="display: none"
                />
                <button type="button" class="cmn-choose-file-btn" (click)="fileInput.click(); $event.stopPropagation()">
                  <img
                    src="assets/images/icons/icon-add-color.svg"
                    alt="Icon Add"
                  />
                  <span>Choose a File</span>
                </button>
                <p class="upload-hint">Drag and drop files here or click to browse</p>
              </div>
            </div>
          </div>

          <div class="uploaded-files-container" *ngIf="csvFile.length > 0">
            <h5>Uploaded Files</h5>
            <div class="uploaded-files-list">
              <div class="uploaded-file-item" *ngFor="let file of csvFile; let i = index">
                <div class="file-info" (click)="onViewDocument(file)">
                  <img src="assets/images/icons/icon-file.svg" alt="File Icon" class="file-icon" />
                  <span class="file-name">{{ file.name ? file.name : file }}</span>
                </div>
                <button type="button" class="remove-file-btn" (click)="removeFile(i)">
                  <img src="assets/images/icons/icon-close.svg" alt="Close Icon" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper" style="display: flex; gap: 15px; justify-content: flex-end;">
        <button class="cmn-draft-btn" type="button" (click)="onSaveAsDraft()" [disabled]="loading">
          <span *ngIf="!loading">Save as Draft</span>
          <span *ngIf="loading">Saving...</span>
        </button>
        <button class="cmn-next-btn" type="submit" [disabled]="loading">
          <span *ngIf="!loading">{{expenseData?.id ? 'Save as Pending' : 'Add as Pending'}}</span>
          <span *ngIf="loading">Loading...</span>
        </button>
      </div>
    </form>
  </section>
</mat-dialog-content>